import type { ButtonHTMLAttributes, Ref } from "react";
import { Icon, type IconName } from "./Icon";
import "./icon-button.css";

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "aria-label"> & {
  /** Il nome del pulsante per gli screen reader (obbligatorio: il pulsante non ha testo). */
  label: string;
  icon: IconName;
  /** Grandezza dell'icona: `sm` 16 px, `md` 20 px. */
  iconSize?: "sm" | "md";
  /** Grandezza del pulsante: `sm` 28 px (dentro un chip o una riga), `md` 36 px. Su touch sempre 44 px. */
  size?: "sm" | "md";
  /** `muted`: icona grigia che si scurisce al passaggio. `inherit`: il colore di dove sta. */
  tone?: "muted" | "inherit";
  /** Arriva al `<button>` (in React 19 `ref` è una prop), per riportarvi il focus. */
  ref?: Ref<HTMLButtonElement>;
};

// Un pulsante con la sola icona: il nome arriva da `label` come `aria-label`. Un `title` si può aggiungere
// per chi usa il mouse, ma non sostituisce il nome.
export function IconButton({ label, icon, iconSize = "sm", size = "sm", tone = "inherit", type = "button", className, ...rest }: Props) {
  return (
    <button
      type={type}
      className={className ? `g-icon-button ${className}` : "g-icon-button"}
      data-size={size}
      data-tone={tone}
      aria-label={label}
      {...rest}
    >
      <Icon name={icon} size={iconSize} />
    </button>
  );
}
